export const TRANSLATIONS = {
  roles: {
    ADMINISTRATOR: "Administrador",
    LIFEGUARD: "Salvavidas",
  },
  status: {
    ACTIVE: "ACTIVO",
    INACTIVE: "INACTIVO",
  },
} as const;
